import * as React from 'react';
import {
    List,
    Datagrid,
    TextField,
    Filter,
    SelectInput,
    TextInput,
    NumberInput,
    BooleanInput,
    TopToolbar,
    Pagination
} from 'react-admin';
import {channels, config, warehouseFilter} from "../config";
import {authorized} from '../authorized'
import {getChannelName} from './channels';
import EditPriorityBtn from "./inventoryPriority/editPriorityBtn";
import SyncPriorityBtn from "./inventoryPriority/syncPriorityBtn";

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const PriorityFilters = (props) => (
    <Filter {...props}>
        <TextInput alwaysOn label="Sku" source="sku"/>
        <SelectInput alwaysOn label="Channel" source="channel_id" choices={channels} optionText="name"
                     optionValue="_id"/>
        <SelectInput alwaysOn label="Warehouse" source="warehouse_id" choices={warehouseFilter} optionValue="_id"
                     optionsText="name"/>
        <TextInput label="Country" source="country"/>
        <TextInput label="Sales Channel" source="sales_channel_name"/>
        <NumberInput label="Priority" source="priority" min={0} step={1}/>
        <BooleanInput label="Backorders" source="backorders"/>
    </Filter>
);

/**
 *
 * @param resource
 * @param filters
 * @param displayedFilters
 * @param filterValues
 * @param basePath
 * @param showFilter
 * @returns {*}
 * @constructor
 */
const PriorityActions = ({resource, filters, displayedFilters, filterValues, basePath, showFilter}) => (
    <TopToolbar style={cardActionStyle}>
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button'
        })}
        <SyncPriorityBtn filterValues={filterValues}/>
    </TopToolbar>
);

const PriorityPagination = props => <Pagination rowsPerPageOptions={[config.perPage]} {...props} />;

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export const InventoryPriorityList = (props) => {
    if (authorized.permissions.indexOf('inventory.priority.list') === -1) {
        return (<span/>)
    }
    return (
        <span>
        <List {...props} actions={<PriorityActions/>}
              filters={<PriorityFilters/>} perPage={config.perPage}
              bulkActionButtons={false}
              pagination={<PriorityPagination/>}
              sort={{field: 'priority', order: 'DESC'}}>
            <Datagrid>
                <SkuText label="SKU" source="sku"/>
                <ChannelName label="Channel" source="channel_id"/>
                <TextField label="Sales Channel" source="sales_channel_name"/>
                <TextField label="Country" source="country"/>
                <TextField label="Warehouse" source="warehouse_name"/>
                <TextField label="Available Qty" source="available_qty"/>
                <TextField label="Priority" source="priority"/>
                <TextField label="Min Qty" source="min_qty"/>
                <BackordersField label="Backorders" source="backorders"/>
                <EditPriorityBtn/>
            </Datagrid>
        </List>
    </span>
    )
};

/**
 *
 * @param record
 * @returns {*}
 * @constructor
 */
const SkuText = ({record = {sku: ""}}) => {
    if (authorized.permissions.indexOf('inventory.log.list') === -1) {
        return (<span className="sku-text">{record.sku}</span>)
    }

    return (<span>
        {record.sku ?
            <a rel="noopener noreferrer" target="_blank" href={'#inventory/' + record.inventory_id + '/show'}
               className="a-customize"
               title="Click here to display details">
                {record.sku}</a> : ''}</span>)
};

/**
 *
 * @param record
 * @returns {*}
 * @constructor
 */
const ChannelName = ({record = {channel_id: ""}}) => {
    return <span>{(record) ? getChannelName(record.channel_id) : record.channel_id}</span>;
};

/**
 *
 * @param record
 * @returns {*}
 * @constructor
 */
const BackordersField = ({record = {}}) => (
    <span>{record.backorders ? 'Yes' : 'No'}</span>
);

/**
 * @type {{display: string, float: string, zIndex: number}}
 */
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
